import { Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { rrules } from "@/utils"

export function RRuleInput({ value, onChange, ...props }: SelectProps) {
  const { t } = useTranslation()
  const data = rrules.map((rrule) => ({ value: rrule.value, label: t(rrule.label) }))
  return (
    <Select
      data={data}
      searchable
      value={value}
      onChange={onChange}
      label={t("Recurrence")}
      placeholder={t("Select recurrence")}
      comboboxProps={{ position: "bottom" }}
      {...props}
    />
  )
}
